import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { of, Subscription } from "rxjs";

import {
  IonContent,
  IonSegmentButton,
  IonSegment,
  AlertController,
  ModalController,
  IonInput,
} from "@ionic/angular";

import { AppComponent } from "../../../app.component";
import { AuthService } from "../../../shared/auth.service";
import { CartService } from "../../../services/cart.service";
import { Category } from "../../../interfaces/category.interface";
import { CategoryService } from "../../../services/category.service";
import { ItemPage } from "../../item/item.page";
import { Product } from "../../../models/produto.model";
import { ProductService } from "../../../services/product.service";
import { RestaurantService } from "../../../services/restaurant.service";
import { StorageService } from "../../../services/storage.service";
import { Utils } from "../../../shared/util";
import { ZimmerStorage } from "../../../models/zimmerStorage.model";
import { QrcodeService } from "src/app/services/qrcode.service";
import { environment } from "src/environments/environment";

declare var Html5Qrcode;

@Component({
  selector: "app-category-new",
  templateUrl: "./category-new.page.html",
  styleUrls: ["./category-new.page.scss"],
})
export class CategoryNewPage implements OnInit {
  /**
   * Todas as categorias do restaurante
   */
  categories: Category[] = [];
  /**
   * Index de qual categoria está em relação ao label, não ao segment. O index é usado no array categoryLenghts
   */
  indexOfCategory: number = 1;
  /**
   * Index de rolagem. A cada rolagem no final da tela ou próximo dela, será somado + 1
   */
  indexVisibleProduct: number = 0;
  /**
   * Categorias a serem mostradas durante a rolagem
   */
  categoryLengths: Category[] = [];
  /**
   * Todos os produtos do restaurante
   */
  products: Product[] = [];
  /**
   * Produtos visíveis
   */
  visibleProducts: Product[] = [];
  /**
   * Diz se foi uma ação clicando em uma das categorias. Se não, apenas rolagem. É usado na função onScroll
   */
  clickAction: boolean;
  /**
   * String mostrada antes do menu de restaurante
   */
  greetings: string;
  /**
   * Título mostrado
   */
  title: string;
  /**
   * Url base
   */
  baseUrl: string; // TODO revisar necessidade

  constructor(
    private alertCtrl: AlertController,
    public auth: AuthService,
    private appComponent: AppComponent,
    public cart: CartService,
    private categoryService: CategoryService,
    private modalCtrl: ModalController,
    private productService: ProductService,
    private restaurantService: RestaurantService,
    private router: Router,
    private storage: StorageService,
    public utils: Utils,
    private qrCodeScanner: QrcodeService
  ) {}

  ngOnInit(): void {
    const cnpj = this.storage.get<string>("cnpj");
    this.setCustomVars();
    const restaurante = this.restaurantService.getRestaurant();

    if (restaurante) {
      this.loadProducts().add(() => {
        this.showMoreProducts();
      });
    } else {
      this.restaurantService.getByCnpj(cnpj).subscribe((restaurant) => {
        this.restaurantService.setRestaurant(restaurant);
        this.loadProducts().add(() => {
          this.showMoreProducts();
        });
      });
    }
  }

  /**
   * Seta as variáveis customizáveis
   */
  setCustomVars(): void {
    const restaurante = this.restaurantService.getRestaurant();
    this.title = restaurante?.nome;
    this.greetings = restaurante?.zimmer;
  }

  /**
   * Retorna uma isncrição depois de popular a variável categories com as categorias salvas em serviço ou requisitadas na API
   */
  loadProducts(): Subscription {
    const categories = this.categoryService.getCategories();

    return categories.length > 0
      ? of(this.categoryService.getCategories()).subscribe((categories) => {
          const produtos: Product[] = [];

          categories.forEach((category) => {
            produtos.push(...category.produtos);
            this.categoryLengths[category.categoriaId] = category;
          });
          this.categories = categories;
          this.products = produtos;
        })
      : this.productService.getAll().subscribe((r) => {
          const result: any[] = (r as any).results;
          const produtos: Product[] = [];

          const categories = result.map((v) => {
            let category: Category = new Object() as Category;
            const keys = Object.keys(v.categoria);
            keys.forEach((key) => {
              category[key] = v.categoria[key];
            });
            category.produtos = v.produtos;
            produtos.push(...v.produtos);
            this.categoryLengths[category.categoriaId] = category;
            return category;
          });

          this.categories = categories;

          this.products = produtos;

          this.categoryService.setCategories(categories);
        });
  }

  /**
   * fnção chamada durante a rolagem do IonContent
   */
  onScroll(content: IonContent): void {
    const fisrtProdutoItem: HTMLElement = document.getElementById(
      "produto-item-" + this.visibleProducts[0].produtoId
    ); // Elemento do primeiro produto de todos
    const firstProdutoItemOnScreen: boolean =
      this.utils.isOnScreen(fisrtProdutoItem); // Primeiro produto está na tela?
    const segment: IonSegment = document.getElementById(
      "segment-category"
    ) as any as IonSegment; // Barra horizontal de categorias
    let categoryId = this.categories[0].categoriaId; // Categoria a ser selecionada - Por padrão, a primeira da lista

    // Se o primeiro produto está na tela
    if (firstProdutoItemOnScreen) {
      // O valor da barra de categorias recebe o valor do botão correspondente ao da categoria do primeiro produto
      segment.value = "segment-button-" + this.visibleProducts[0].categoriaId;
      // Pega o botão da categoria que será selecionada
      const button = document.getElementById(
        "segment-button-" + categoryId
      ) as any as IonSegmentButton;
      // Rola até ele
      (segment as any as HTMLElement).scrollTo({
        left: button["offsetLeft"] - 30,
        behavior: "smooth",
      });
      segment.value = "segment-button-" + categoryId;
      // Se não, se não for um clique no botão de categoria
    } else if (!this.clickAction) {
      // Pega o scroll do IonContent
      content.getScrollElement().then((scroll) => {
        const scrollTop = scroll.scrollTop; // Scroll atual do IonContent

        if (scrollTop) {
          const totalScroll = scroll.scrollHeight - scroll.offsetHeight; // Calcula o scroll restante (scrollDisponível - ScrollJáRolado)

          // Dou reverse no array para que procure primeiro pelos últimos - Não passa por todos novamente (mais rápido).
          // Uso o spreadOperator para que o array principal não seja afetado.
          for (const product of [...this.visibleProducts].reverse()) {
            const element = document.getElementById(
              "produto-item-" + product.produtoId
            );
            const isOnScreen = this.utils.isOnScreen(element);
            // console.log(product, isOnScreen, 'produto está na tela?')

            // Se o elemento estiver na tela, a categoria a ser selecionada será essa
            if (isOnScreen) {
              categoryId = product.categoriaId;
              // Para o loop
              break;
            }
          }

          // Se o total a ser rolado for <= à rolagem atual E contador de
          // rolagens(indexVisibleProduct) * 15 <= que o tamanho do array de produtos visíveis
          if (
            totalScroll <= scrollTop + 200 &&
            this.indexVisibleProduct * 15 <= this.visibleProducts.length
          ) {
            this.indexVisibleProduct++; // Adiciona + 1 no contador de rolagens
            this.showMoreProducts(); // Adiciona mais produtos no array de produtos visíveis
          }
        }
        // Rola e seleciona para a categoria de produtos escolhida
        const button = document.getElementById(
          "segment-button-" + categoryId
        ) as any as IonSegmentButton;
        (segment as any as HTMLElement).scrollTo({
          left: button["offsetLeft"] - 30,
          behavior: "smooth",
        });
        segment.value = "segment-button-" + categoryId;
      });
    }
  }

  /**
   * Adiciona mais produtos nos produtos visíveis (geralmente + 15). Número de rolagens * 15
   */
  showMoreProducts(): void {
    this.visibleProducts = [...this.products].splice(
      0,
      ++this.indexVisibleProduct * 15
    );
  }

  /**
   * Checa se este é o primeiro produto de uma lista de categorias. Caso sim, será exibido um label com o nome da categoria acimma dele
   */
  showCategoryLabel(product: Product, i: number): boolean {
    if (product.categoriaId != this.products[i - 1]?.categoriaId) {
      this.indexOfCategory++;
      return true;
    } else return false;
  }

  /**
   * Rola a tela até que chegue no primeiro do produto da categoria selecionada
   * @param { number } categoryId
   */
  scrollToCategory(categoryId: number): void {
    // Diz que a ação de scroll é realizada por um click na barra de categorias
    this.clickAction = true;
    // Procura o index do primeiro produto da categoria selecionada na lista de produtos visíveis (retorna -1 caso não ache)
    let indexFirstProductOfCategory = this.visibleProducts.findIndex(
      (product) => product.categoriaId == categoryId
    );

    // Enquanto não achar
    while (indexFirstProductOfCategory == -1) {
      // Adiciona mais produtos à lista de produtos visíveis
      this.showMoreProducts();
      // Procura o index do primeiro produto da categoria selecionada na lista de produtos visíveis (retorna -1 caso não ache)
      indexFirstProductOfCategory = this.visibleProducts.findIndex(
        (product) => product.categoriaId == categoryId
      );
    }

    // Timeout é pra que sejam renderizado os produtos na tela antes de fazer a busca.
    // O tempo de espera é 0 porque o fato de o setTimeout ser assíncrono já é o suficiente
    // para que ele processe a página antes desse bloco de comando
    setTimeout(() => {
      // Procura o elemento HTML do card do produto
      const produtoItem = document.getElementById(
        "produto-item-" +
          this.visibleProducts[indexFirstProductOfCategory].produtoId
      );
      // Busca o IonContent que será scrollado
      const content = document.getElementById(
        "ion-content-products"
      ) as any as IonContent;
      // Por causa de diferenças no design, se o card foor do tipo 1, ele tem que pegar o offsetTop do elemento pai.
      // Se não, o dele mesmo. Para QUALQUER alteração no design da página deve ser feita a revisão da funcionalidade de scroll
      const offsetTop =
        produtoItem.classList[0] == "style-1"
          ? produtoItem.parentElement.offsetTop
          : produtoItem.offsetTop;

      content.getScrollElement().then((scroll) => {
        scroll.scrollTo({
          behavior: "smooth",
          top: offsetTop,
        });
        // Para que seja scrollado depois sem ser pelo click, tem que passar a variável pra false. NÃO ESQUEÇA
        this.clickAction = false;
      });
    }, 0);
  }

  /**
   * Abre o modal com o carrinho
   */
  openCart(): void {
    const items = this.cart.getAllItems();
    this.cart.showCart(items);
  }

  /**
   * Fecha o modal atual (esta Page caso ela esteja aberta em forma de modal)
   */
  closeModals(): void {
    this.modalCtrl.dismiss();
  }

  /**
   * Mostra os detalhes do item selecionado em forma de modal
   * @param prod
   */
  showItemDetails(prod: Product): void {
    this.modalCtrl
      .create({
        component: ItemPage,
        componentProps: {
          openCartFn: this.openCart,
          prod,
        },
        cssClass: "modal-fullscreen",
      })
      .then((modal) => modal.present());
  }

  /**
   * Procura um produto com o nome digitado
   * @param value
   */
  searchProd(value: string | number): void {
    if ((value + "").length > 0)
      this.visibleProducts = this.products.filter((prod) =>
        prod.nome.toLowerCase().includes((value + "").toLowerCase())
      );
    else
      this.visibleProducts = this.products.filter((prod) =>
        prod.nome.toLowerCase().includes((value + "").toLowerCase())
      );
  }

  /**
   * Toggle da classe showing no input selecionado (evento específico do DOM)
   * @param searchInput Input a ser manipulado
   */
  searchButtonClick(searchInput: IonInput): void {
    searchInput["el"].className = !searchInput["el"].className.includes(
      "showing"
    )
      ? searchInput["el"].className + " showing"
      : searchInput["el"].className.replace("showing", "");
    searchInput.setFocus();
  }

  /**
   * Evento **blur** do elemento selecionado (evento específico do DOM)
   * @param searchInput
   */
  searchBarInputBlur(searchInput: IonInput): void {
    searchInput.value?.toString().length == 0
      ? (searchInput["el"].className = searchInput["el"].className.replace(
          "showing",
          ""
        ))
      : false;
  }

  /**
   * Troca de mesa
   */
  changeTableClick(): void {
    const type = this.storage.get("type");
    if (type == "qrcode")
      this.utils.scanQr().then((result) => {
        const results = result.text.split("qrcode/")[1].split("/");
        const table = results[1];
        this.auth.changeTable(Number(table));
      });
    else this.setTable();
  }

  /**
   * Chama a câmera para escanear o QRCode
   */
  scan(): void {
    this.utils
      .scanQr()
      .then((result) => {
        const results = result.text.split("qrcode/")[1].split("/");
        const cnpj = results[0];
        const table = results[1];
        const zimmer = new Object() as ZimmerStorage;
        zimmer.cnpj = cnpj;
        zimmer.tableNumber = Number(table);
        zimmer.mode = environment.appModes.table as
          | "zap"
          | "qrcode"
          | "ficha"
          | "menu"
          | "pedido"
          | "gestor";
        this.storage.prepare(zimmer);

        // this.router.navigate([cnpj])
        this.router.navigate([zimmer.cnpj]);
        return true;
      })
      .catch((error) => {
        this.alertCtrl
          .create({
            header: "Error scanner",
            message: JSON.stringify(error),
          })
          .then((alert) => alert.present());
        return false;
      });
  }

  /**
   * Mostra o alert para setar o número de uma mesa no storage
   */
  setTable(): void {
    const type: "qrcode" | "credetials" = this.storage.get("type");
    this.auth.setTable();
  }

  /**
   * Verifica o estilo em que será mostrados os produtos
   */
  checkItemStyle(): string | number {
    return this.categoryService.checkItemStyle();
  }

  /**
   * Busca o ID do pedido salvo no SessionStorage
   */
  getPedidoId(): string | number {
    return this.cart.getPedidoIdInSession();
  }

  // testCam() {
  //   Html5Qrcode.getCameras().then(devices => { // TODO Fazer pra procurar facing back e facing front (pra garantir que procure pela traseira, até então, os últimos índices do array são back)
  //     document.getElementById('teste-cam').innerHTML = (devices.map((device, index) => `<span>device ${index} ${JSON.stringify(devices[index])}</span><br>`) as []).join('')
  //     // setTimeout(() => {
  //     //   const cam = new Html5Qrcode('teste-cam')
  //     //   cam.start(devices[1]?.id || devices[0]?.id, { fps: 1 }, text => console.log(text), error => console.log(error)).catch(err => console.log('deu pra abrir nao'))
  //     // }, 100000)
  //   })
  //   this.qrCodeScanner.scan({
  //     side: 'back',
  //     useNativePlugin: false
  //   })
  // }
}
